import { LocalIdentityProfileSchema, type LocalIdentityProfile } from '@trivoa/shared';

export function getLocalIdentityProfile(): LocalIdentityProfile | null {
  const value = import.meta.env.VITE_LOCAL_IDENTITY_USER;
  if (value === undefined) return {
    key: 'admin-a', id: '5309bf4e-05a4-47d7-8f16-f4f9192a8498', clerkId: 'local-development-user',
    tenantId: '3c596476-1283-45ab-8ef5-f444af465ad6', role: 'ADMIN', email: 'local@trivoa.test', fullName: 'Local Trivoa Admin',
  };
  try {
    if (typeof value !== 'string' || value.length > 4096) return null;
    const parsed = LocalIdentityProfileSchema.safeParse(JSON.parse(value));
    return parsed.success ? parsed.data : null;
  } catch { return null; }
}

/** Local credentials are accepted only by the explicit loopback development server. */
export function isLocalIdentityMode(): boolean {
  return Boolean(import.meta.env.DEV)
    && import.meta.env.MODE === 'local-development'
    && import.meta.env.VITE_LOCAL_IDENTITY_ENABLED === 'true'
    && typeof import.meta.env.VITE_LOCAL_IDENTITY_TOKEN === 'string'
    && import.meta.env.VITE_LOCAL_IDENTITY_TOKEN.length >= 32
    && typeof window !== 'undefined'
    && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
    && getLocalIdentityProfile() !== null;
}
